import { STRAPI_IMGX } from '../../constants'
import { VeeImage } from '../../models/types/Image.type'

export const renderImage = ({ hash, ext }: VeeImage) => {
  const IMG = { width: 388, height: 276 }
  const LISTICLE_SETTINGS = `?auto=format&sharp=5&con=15&fit=crop&w=${IMG.width * 2}&h=${IMG.height * 2}`
  return `${STRAPI_IMGX}/${hash + ext}${LISTICLE_SETTINGS}`
}
